import { createApi } from "@reduxjs/toolkit/query/react";

export const supabaseApi = createApi({
  reducerPath: "supabaseApi",
  baseQuery: async () => ({ data: null }), // Dummy baseQuery
  tagTypes: ["deputy_reviews"], // Supabase tags or any additional tags
  endpoints: () => ({}),
});
